export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const FETCH_COLLECTIONS = 'FETCH_COLLECTIONS';
export const FETCH_STATISTICS = 'FETCH_STATISTICS';